import { CommonState } from "../../../redux/common/commonSlice";
import { categoryItems, getSearchCategoryShared, getSearchProviderShared, updateSearchParamsForCategoryShared, updateSearchParamsForProviderShared } from "../../shared/sharedHelper";

export const configurationsParamKeys = {
    provider: 'provider',
    category: 'category'
}

export const getSearchProvider = (searchParams: URLSearchParams) => {
    return getSearchProviderShared(searchParams, configurationsParamKeys.provider);
}

export const getSearchCategory = (searchParams: URLSearchParams) => {
    return getSearchCategoryShared(searchParams, configurationsParamKeys.category);
}

export const updateSearchParamsForProvider = (searchParams: URLSearchParams, providerCode: string) => {
    return updateSearchParamsForProviderShared(searchParams, providerCode, configurationsParamKeys.provider);
}

export const updateSearchParamsForCategory = (searchParams: URLSearchParams, categoryCode: string) => {
    return updateSearchParamsForCategoryShared(searchParams, categoryCode, configurationsParamKeys.category);
}

export const initialSearchParams = (
    searchParams: URLSearchParams, common: CommonState, setSearchParams: (searchParams: URLSearchParams) => void
) => {
    const searchProvider = getSearchProvider(searchParams);
    const searchCategory = getSearchCategory(searchParams);

    if (!searchProvider || !searchCategory) {
        let newSearchParams = searchParams;
        if (!searchProvider) {
            newSearchParams = updateSearchParamsForProvider(
                searchParams, common.providers.length > 0 ? common.providers[0].code : 'betmakers'
            );
        }
        if (!searchCategory) {
            newSearchParams = updateSearchParamsForCategory(searchParams, categoryItems[0].key);
        }
        setSearchParams(newSearchParams);
    }
}
